import type SVGType from 'types/svg.types';

const RepeatIcon: SVGType = ({ pathClassName, ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="none"
    strokeWidth="1.5"
    {...props}
  >
    <path
      d="M16.75 4.75L19.25 7L16.75 9.25"
      stroke="currentColor"
      strokeWidth="inherit"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7.25 19.25L4.75 17L7.25 14.75"
      stroke="currentColor"
      strokeWidth="inherit"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M18.5 7H9.75C6.98858 7 4.75 9.23858 4.75 12V12.25"
      stroke="currentColor"
      strokeWidth="inherit"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5.75 17H14.25C17.0114 17 19.25 14.7614 19.25 12V11.75"
      stroke="currentColor"
      strokeWidth="inherit"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default RepeatIcon;
